export { EloScalesIcon } from './scales-icon'
